import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Parent} from "../../models/parent";

@Injectable({
  providedIn: 'root'
})
export class ParentService {

  formData: FormData = new FormData();

  constructor(private http: HttpClient) { }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': environment.publicApiToken,
    });
  }

  getFormDataRequestHeaders() {
    return new HttpHeaders({
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  async updateProfilePicture(formData: FormData, parentId?: string) {

    let response: any;

    try {
      response = await this.http.post(environment.apiUrl + `/parents/upload`, formData, {
        headers: this.getFormDataRequestHeaders(),
      }).toPromise();

      return response

    } catch (e) {
      console.error('error updateProfilePicture: ', e)
    }

  }

  async updateParent(updatedParent: Parent) {
    let response: any;

    try {
      response = await this.http.put(environment.apiUrl + `/parents/${updatedParent.id}`, updatedParent, {headers: this.getRequestHeaders()}).toPromise();
      return response.success;
    } catch (e) {
      console.error('error updateParent: ', e)
      return false;
    }
  }

  async addParent(newParent: Parent): Promise<boolean> {
    let response: any;

    try {
      response = await this.http.post(environment.apiUrl + `/parents`, newParent, {headers: this.getRequestHeaders()}).toPromise();
      return response.success;
    } catch (e) {
      console.error('error updateParent: ', e)
      return false;
    }
  }

  async getParentByAthleteId(athleteId?: string) { //athleteParent
    let response: any;
    try {
      response = await this.http.get(environment.apiUrl + `/athleteParent/${athleteId}`, {headers: this.getRequestHeaders()}).toPromise();
      return response.data;
    } catch (e) {
      console.error('error updateParent: ', e)
      return false;
    }
  }

  async deleteParent(parentId?: string | undefined) {
    let response: any;
    try {
      response = await this.http.delete(environment.apiUrl + `/parents/${parentId}`, {headers: this.getRequestHeaders()}).toPromise();
      return response.data;
    } catch (e) {
      console.error('error deleteParent: ', e)
      return false;
    }
  }
}
